import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import './JobDetails.css';
import { API_BASE_URL } from '../config/apiConfig';

function JobDetails() {
  const { id } = useParams();
  const [job, setJob] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/jobs/${id}`)
      .then(res => res.json())
      .then(data => setJob(data))
      .catch(() => setJob(null));
  }, [id]);

  if (!job) return <p>Loading job details...</p>;

  // Safely parse lastDate
  const lastDateObj = job.lastDate ? new Date(job.lastDate) : null;
  const postDateObj = job.postedDate ? new Date(job.postedDate) : null;
  const now = new Date();
  const timeDiff = lastDateObj ? lastDateObj - now : null;
  const daysLeft = timeDiff !== null ? Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) : null;
  const postTimeDiff = postDateObj ? now - postDateObj : null;
  const daysBefore = postTimeDiff !== null ? Math.ceil(postTimeDiff / (1000 * 60 * 60 * 24)) : null;

  // Status badge logic
  let statusBadge = <span className="status-badge">⏳ Unknown</span>;
  if (daysLeft !== null) {
    if (daysLeft < 0) {
      statusBadge = <span className="status-badge expired">❌ Expired</span>;
    } else if (daysLeft <= 3) {
      statusBadge = <span className="status-badge soon">⚠️ Expiring Soon</span>;
    } else {
      statusBadge = <span className="status-badge active">✅ Active</span>;
    }
  }

  // Status posted date logic
  let posted = <span >⏳ Unknown</span>;
  if (daysBefore !== null) {
    if (daysBefore === 0) {
      posted = <span> Today</span>;
    } else if (daysBefore === 1) {
      posted = <span>Yesterday</span>;
    } else if (daysBefore <= 7) {
      posted = <span>{daysBefore} days ago</span>;
    } else if (daysBefore <= 30) {
      posted = <span>{Math.floor(daysBefore / 7)} weeks ago</span>;
    } else if (daysBefore <= 365) {
      posted = <span>{Math.floor(daysBefore / 30)} months ago</span>;
    } else if (daysBefore > 365) {
      posted = <span>{Math.floor(daysBefore / 365)} years ago</span>;
    } else {
      posted = <span> Unknown </span>
    }
  }

  return (
    <div className="job-details-container">
      <h5>Application Status: {statusBadge}</h5>
      <p style={{ fontSize: '0.9em', textAlign: 'right' }}>
        Posted: {job.postedDate ? posted : '_'}
      </p>
      <h2>{job.title}</h2>
      <p><strong>Department:</strong> {job.department}</p>
      <p><strong>Qualification:</strong> {job.qualification}</p>
      <p><strong>Job Location:</strong> {job.location}</p>

      {/* 🕒 Timeline */}
      <p>
        <strong>Start Date:</strong>
        <span style={{ color: 'green', fontSize:'inherit', fontWeight:'bold'}}> {job.startDate ? dayjs(job.startDate).format('MMMM D, YYYY') : '_'}</span>
      </p>
      <p >
        <strong>Last Date to Apply:</strong>
        <span style={{ color: 'red', fontSize:'inherit', fontWeight:'bold'}}> {job.lastDate ? dayjs(job.lastDate).format('MMMM D, YYYY') : '_'}</span>
      </p>

      {/* 🔗 Notification */}
      <p><strong>Detailed Notification PDF:</strong>{' '}
        <a href={job.notificationLink} target="_blank" rel="noopener noreferrer">
          Download Advertisement
        </a>
      </p>

      {/* 🔗 Application */}
      <p><strong>Application Link:</strong>{' '}
        <a href={job.applicationLink} target="_blank" rel="noopener noreferrer">
          Apply Here
        </a>
      </p>

      <p><strong>Admit Card Release:</strong> {job.admitCardRelease || '_'}</p>
      <p><strong>Exam Date:</strong> {job.examDate || '_'}</p>
      <p><strong>Result Date:</strong> {job.resultDate || '_'}</p>

      {/* 🔗 Official Website */}
      <p><strong>Source:</strong>{' '}
        <a href={job.officialLink} target="_blank" rel="noopener noreferrer">
          Go to official website ...
        </a>
      </p>

      {/* 🔗 Previous Year Question Papers */}
      <p><strong>Previous Year Question Paper:</strong>{' '}
        <a href={job.pyqPaperLink} target="_blank" rel="noopener noreferrer">
          {job.pyqPaperLink ? 'Download PYQ Paper' : 'Coming soon, if Available'}
        </a>
      </p>
    </div>
  );
}

export default JobDetails;
